import {LOOKUP_ENUM} from "../../dictionary/core/lookup.enum";
export const QUOTE_HEADER_STATUS = LOOKUP_ENUM.QUOTE_HEADER_STATUS;
